import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Modal } from 'ui/components/Modal/Modal/Modal';
import { SalesOrderAsyncAutocomplete } from 'ui/components/Autocomplete/SalesOrderAsyncAutocomplete';
import { SalesOrder } from 'services/salesOrders';

interface SalesOrderSelectModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (salesOrder: SalesOrder | null) => void;
}

const SalesOrderSelectModal = ({
  open,
  onClose,
  onConfirm,
}: SalesOrderSelectModalProps) => {
  const [selectedSalesOrder, setSelectedSalesOrder] =
    useState<SalesOrder | null>(null);

  const handleConfirm = () => {
    onConfirm(selectedSalesOrder);
    setSelectedSalesOrder(null);
  };

  const handleCancel = () => {
    setSelectedSalesOrder(null);
    onClose();
  };

  return (
    <Modal
      open={open}
      title="Select Sales Order for Preview"
      applyLabel="Preview"
      cancelLabel="Cancel"
      maxWidth="xs"
      onApplyClicked={handleConfirm}
      onCancelClicked={handleCancel}
      applyDisabled={!selectedSalesOrder}
      dataQa="sales-order-select-modal"
    >
      <Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Choose a sales order to preview your template with real data
        </Typography>

        <SalesOrderAsyncAutocomplete
          label="Sales Order Number"
          value={selectedSalesOrder?.id ?? null}
          onChange={setSelectedSalesOrder}
          placeholder="Select Sales Order"
          dataQa="sales-order-modal-number-field"
          customQuickSearchColumns={['number']}
          expands={[
            'location',
            'carrier',
            'salesOrderItems',
            'salesOrderBundleItems.salesOrderItems',
          ]}
          required
        />
      </Box>
    </Modal>
  );
};

export default SalesOrderSelectModal;
